export const CONST_APIURLKUSALA =
  window.location.protocol +
  "//" +
  window.location.hostname +
  "/dolibarr/api/index.php/";
